import { ref, watch } from "vue"
import { useRoute } from "vue-router"

const title = ref("")
export default () => {
  const setTitle = (newTitle: string) => (title.value = newTitle)

  const route = useRoute()
  watch(
    route,
    () => {
      if (route.meta?.title) {
        setTitle(route.meta.title.toString())
      }
    },
    { immediate: true },
  )

  return {
    title,
    setTitle,
  }
}
